<template>
    <div v-if="item" :class="`item-page ${menuType}-background-color pb-4`">
        <div class="page">
            <div class="sticky-container bg-white">
                <nav class="container navbar navbar-light">
                    <a class="d-flex justify-content-between" href="#" v-on:click="!preview ? back() : ''">
                        <svg class="back-icon align-self-center" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
                            <path d="M0 0h24v24H0z" fill="none" />
                            <path d="M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z" />
                        </svg>
                        <div class="navbar-text align-self-center">{{ $t("Back") }}</div>
                    </a>

                    <router-link class="d-flex justify-content-between" :to="!preview ? `/${site}/cart` : ''">
                        <div class="align-self-center">
                            <svg :class="`shopping-bag-${menuType} align-self-center`" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="34" height="34">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M17.21 9l-4.38-6.56a.993.993 0 00-.83-.42c-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z" />
                            </svg>
                            <span v-if="cart && cart.extra && cart.extra.number_of_items > 0" class="badge badge-primary badge-pill custom-card-qty">
                                {{ cart.extra.number_of_items }}
                            </span>
                        </div>
                        <div class="navbar-price align-self-center mt-2" v-if="cart && cart.extra.number_of_items > 0">{{ cartTotalAmount | moneyFormat }}</div>
                    </router-link>
                </nav>
            </div>

            <div :class="`py-3 sticky-container border-top ${menuType}-background-color`" style="top: 59px;">
                <div class="container item-header">
                    <div :class="`${menuType}-item-title`" class="item-title">{{ item.name }}</div>
                    <div :class="`${menuType}-item-price text-nowrap`" class="item-price">
                        <span v-if="item.price > 0">{{ item.price | moneyFormat }}</span>
                    </div>
                </div>
            </div>

            <div :class="`body container ${menuType}-background-color`" v-if="item">
                <div class="text-danger mb-2" v-if="item.current_stock <= item.stock_warning">
                    <span class="font-weight-bold">*</span> {{ $t("There are only {items} products left.", { items: item.current_stock }) }}
                </div>

                <div :class="`${menuType}-item-description`">
                    <p style="white-space: pre-wrap">{{ item.long_description }}</p>
                    <small v-if="totalCalories > 0">{{ $t("Calories:") }} <strong>{{ totalCalories }}</strong></small>
                </div>

                <div :class="`${menuType}-allergens-list`" class="filters-list" v-if="item.allergens">
                    <div>{{ $t("Allergens") }}</div>
                    <ul class="filters">
                        <li v-for="allergen in item.allergens" :key="allergen.id">
                            <span class="allergens-sm">
                                {{ allergen.allergen_name }}
                            </span>
                        </li>
                    </ul>
                </div>

                <hr v-if="item.modifier_groups.length">

                <div v-for="group in item.modifier_groups" :key="group.id" class="option">
                    <h4 :class="`${menuType}-option-header`">{{ group.name }}</h4>

                    <div class="errors" v-if="groupErrors(group).length">
                        <div v-for="(error, index) in groupErrors(group)" :key="index" class="text-danger">
                            {{ error.message }}
                        </div>
                    </div>

                    <div v-if="group.style == 'single'" class="option">
                        <div v-for="modifier in group.modifiers" :key="modifier.id" :class="`option-item ${modifier.current_stock == 0 ? menuType + '-not-available menu-item-not-available item-show' : ''}`">
                            <div class="radio form-check form-check-inline">
                                <div>
                                    <input class="form-check-input" type="radio" :name="`group-${group.id}`" :id="`modifier-${modifier.id}`" :value="modifier.id" v-model="group.selected" v-on:click="changeSingleGroup($event, group)" :disabled="modifier.current_stock == 0">
                                </div>

                                <label class="form-check-label" :name="`group-${group.id}`" :for="`modifier-${modifier.id}`">
                                    {{ modifier.name }}
                                </label>
                            </div>

                            <div class="quantity" v-if="modifier.id == group.selected && (!modifier.max || modifier.max > 1)">
                                <button :disabled="modifier.quantity < 2" v-on:click="modifier.quantity--" class="btn minus1">-</button>
                                <input v-model="modifier.quantity" min="1" :max="modifier.max || 1000" type="number">
                                <button :disabled="modifier.quantity >= (modifier.max || 1000)" v-on:click="modifier.quantity++" class="btn add1">+</button>
                            </div>

                            <div class="option-item-price text-nowrap">
                                <div v-if="modifier.price > 0" class="text-right">
                                    <span v-if="!group.primary">+</span>
                                    {{ modifier.price * modifier.quantity | moneyFormat }}
                                </div>

                                <div v-if="modifier.calories_amount && modifier.calories_amount > 0" class="font-italic text-right small">
                                    <span v-if="!group.primary">+</span>
                                    {{ modifier.calories_amount }} {{ $t("kcal") }}
                                </div>
                            </div>

                            <div class="errors" v-if="modifierErrors(group, modifier).length">
                                <div v-for="(error, index) in modifierErrors(group, modifier)" :key="index" class="text-danger">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-else-if="group.style == 'multiple'" class="option">
                        <div v-for="modifier in group.modifiers" :key="modifier.id" :class="`option-item ${modifier.current_stock == 0 ? menuType + '-not-available menu-item-not-available item-show' : ''}`">
                            <div class="checkbox form-check form-check-inline">
                                <input class="form-check-input" type="checkbox" :id="`modifier-${modifier.id}`" v-model="modifier.selected" :disabled="modifier.current_stock == 0">

                                <label class="form-check-label" :for="`modifier-${modifier.id}`">
                                    {{ modifier.name }}
                                </label>
                            </div>

                            <div class="quantity" v-if="modifier.selected && (!modifier.max || modifier.max > 1)">
                                <button :disabled="modifier.quantity < 2" v-on:click="modifier.quantity--" class="btn minus1">-</button>
                                <input v-model="modifier.quantity" min="1" :max="modifier.max || 1000" type="number">
                                <button :disabled="modifier.quantity >= (modifier.max || 1000)" v-on:click="modifier.quantity++" class="btn add1">+</button>
                            </div>

                            <div class="option-item-price text-nowrap">
                                <div v-if="modifier.price > 0" class="text-right">
                                    + {{ modifier.price * modifier.quantity | moneyFormat }}
                                </div>

                                <div v-if="modifier.calories_amount && modifier.calories_amount > 0" class="font-italic text-right small">
                                    + {{ modifier.calories_amount }} {{ $t("kcal") }}
                                </div>
                            </div>

                            <div class="errors" v-if="modifierErrors(group, modifier).length">
                                <div v-for="(error, index) in modifierErrors(group, modifier)" :key="index" class="text-danger">
                                    {{ error.message }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="option mb-4" v-if="item.accepts_notes">
                    <h4 :class="`${menuType}-option-header mt-4 mb-2`">{{ $t("Notes") }}</h4>
                    <textarea class="form-control" rows="2" maxlength="50" v-model="item.notes"></textarea>
                    <p class='text-right text-small text-italic' v-bind:class="{ 'text-danger': item.notes.length > 40, 'text-muted': item.notes.length <= 40 }">{{ item.notes.length }} / 50</p>
                </div>

                <banner location="menu-item-bottom"></banner>
            </div>

            <div :class="`sticky-container mobile-bottom-padding ${menuType}-background-color`">
                <div class="container ">
                    <div class="d-flex justify-content-between my-4">
                        <div class="quantity d-flex justify-content-center">
                            <button :disabled="item.quantity < 2" v-on:click="item.quantity--" class="btn minus1 px-0">-</button>
                            <input class="px-0" v-model="item.quantity" min="1" type="number">
                            <button v-on:click="item.quantity++" class="btn add1 px-0">+</button>
                        </div>
                        <div class="text-center">
                            <button type="button" class="btn btn-primary btn-basket px-2 px-sm-4" v-on:click="!preview ? addToCart() : null">{{ $t("Add to basket") }} ({{ totalAmount() | moneyFormat }})</button>
                        </div>
                    </div>
                </div>
            </div>

            <modal name="error-modal" width="100%" height="auto">
                <div class="p-3">
                    <div class="text-center mt-3">
                        <h3 id="modal-headline">
                            {{ $t("Please note") }}
                        </h3>
                        <div class="mt-3">
                            <p v-for="(error, index) in errors" :key="index" style="color: rgb(150, 35, 35)" class="text-center">
                                <span style="color: black" v-if="errors.length > 1">{{ index + 1 }}.</span>
                                {{ error.message }}
                            </p>
                        </div>
                    </div>
                </div>

                <hr>

                <div class="flex justify-content-center border-solid mt-4 pt-1 mb-4">
                    <button class="btn btn-primary mr-2" v-on:click="$modal.hide('error-modal')">{{ $t("Close") }}</button>
                </div>
            </modal>
        </div>
    </div>
</template>

<script>
import Banner from '../../components/Banner';

export default {
    components: { Banner },
    data() {
        return {
            item: null,
            menus: [],
            errors: [],
            menuType: this.$route.params.menu,
            site: this.$route.params.site,
            cart: window.app.cart,
            previousUrl: null,
            preview: this.$route.query.preview
        };
    },
    computed: {
        cartTotalAmount() {
            return Math.max(0, (this.cart.extra.total_amount
                - this.cart.extra.discounts.total_discount
                - (this.cart.extra.eotho_discount_amount || 0)
            )
            );
        },
        totalCalories() {
            if (!this.item) {
                return 0;
            }

            let totalCalories = this.item.calories_amount || 0;

            // Find the primary group, if it exists
            const primaryGroup = this
                .item
                .modifier_groups
                .find(m => m.primary);

            if (primaryGroup) {
                // If there is a primary group but it has no modifier selected, then calories amount have no sense
                if (!primaryGroup.selected) {
                    return 0;
                }

                // Get the calories of the primary checked modifier and replace the original (now virtual) item calories
                const primaryCheckedModifier = primaryGroup
                    .modifiers
                    .find(m => m.id === primaryGroup.selected);

                totalCalories = primaryCheckedModifier.calories_amount || 0;
            }

            // The non-primary groups
            const remainingGroups = this
                .item
                .modifier_groups
                .filter(m => !m.primary);

            for (let group of remainingGroups) {
                if (group.style === 'single') {
                    if (!group.selected) {
                        continue;
                    }

                    const selectedModifier = group.modifiers.find(m => m.id === group.selected);

                    totalCalories += (selectedModifier.calories_amount || 0) * selectedModifier.quantity;
                }

                if (group.style === 'multiple') {
                    group
                        .modifiers
                        .filter(m => m.selected)
                        .forEach(m => totalCalories += (m.calories_amount || 0) * m.quantity);
                }
            }

            return totalCalories;
        }
    },
    watch: {
        item: {
            deep: true,
            handler(item) {
                if (!this.errors.length) {
                    return;
                }

                for (let group of item.modifier_groups) {
                    if (!group.min && !group.max) {
                        continue;
                    }

                    let options_selected_count = 0;

                    for (let modifier of group.modifiers) {
                        if (!modifier.selected && modifier.id != group.selected) {
                            continue;
                        }

                        options_selected_count += modifier.quantity || 1;

                        if ((modifier.quantity || 1) <= (modifier.max || Number.MAX_SAFE_INTEGER)) {
                            let current_errors = this.errors.filter(e => e.group_id == group.id && e.modifier_id == modifier.id && e.code == 'MODIFIER_BIG');

                            this.errors = this.errors.filter(e => !current_errors.includes(e));
                        }

                        if ((modifier.quantity || 1) >= (modifier.min || 1)) {
                            let current_errors = this.errors.filter(e => e.group_id == group.id && e.modifier_id == modifier.id && e.code == 'MODIFIER_SMALL');

                            this.errors = this.errors.filter(e => !current_errors.includes(e));
                        }
                    }

                    if (options_selected_count >= (group.min || (group.required ? 1 : 0))) {
                        let current_errors = this.errors.filter(e => e.group_id == group.id && e.code == 'GROUP_SELECTED_MODIFIERS_SMALL');

                        this.errors = this.errors.filter(e => !current_errors.includes(e));
                    }

                    if (options_selected_count <= (group.max || Number.MAX_SAFE_INTEGER)) {
                        let current_errors = this.errors.filter(e => e.group_id == group.id && e.code == 'GROUP_SELECTED_MODIFIERS_BIG');

                        this.errors = this.errors.filter(e => !current_errors.includes(e));
                    }
                }
            }
        }
    },
    methods: {
        fetchItem() {
            this.$axios
                .get(`/items/${this.$route.params.item}`, {
                    params: {
                        site_slug: this.site,
                        menu_type: this.menuType,
                        preview: this.preview
                    }
                })
                .then(response => {
                    response.data.item.quantity = 1;
                    response.data.item.notes = '';

                    response.data.item.modifier_groups.forEach(group => {
                        group.modifiers.forEach(modifier => {
                            if (group.style == 'multiple') {
                                modifier.selected = false
                            }
                            modifier.quantity = 1;
                        });

                        if (group.style == 'single') {
                            if (group.primary == true) {
                                return group.selected = group.modifiers[0].id
                            }

                            return group.selected = null;
                        }
                    });

                    this.item = response.data.item;
                })
                .catch(error => {
                    this.$router.replace(`/error/${error.response.status}`);
                });
        },
        fetchMenus() {
            this.$axios
                .get(`/menus?site_slug=${this.site}`)
                .then(response => {
                    this.menus = response.data.items;
                })
                .catch(error => {
                    this.$router.replace(`/error/${error.response.status}`);
                });
        },
        addToCart() {
            this.$axios
                .post(`/${this.site}/carts`, {
                    item: this.item,
                    menu_type: this.menuType,
                    menu_section_id: this.$route.params.section
                })
                .then(response => {
                    if (this.previousUrl.query.section_id) {
                        window.location.href = `/${this.$route.params.site}/${this.$route.params.menu}?section_id=${this.previousUrl.query.section_id}&add=true`;
                    } else {
                        window.location.href = `/${this.$route.params.site}/${this.$route.params.menu}?add=true`;
                    }
                })
                .catch(error => {
                    if (!error.response.data.errors) {
                        this.errors = [{ message: error.response.data }];
                    } else {
                        this.errors = error.response.data.errors;
                    }

                    this.$modal.show('error-modal');
                });
        },
        modifierErrors(group, modifier) {
            return this.errors.filter(e => e.modifier_id == modifier.id && e.group_id == group.id);
        },
        groupErrors(group) {
            return this.errors.filter(e => e.group_id == group.id && e.modifier_id == null);
        },
        changeSingleGroup($event, group) {
            !group.required ? group.selected = null : null;

            if (group.primary) {
                let modifier = group.modifiers.find(g => g.id == $event.target.value);

                this.item.price = modifier.price;
            }
        },
        totalAmount() {
            let price = parseFloat(this.item.price);

            for (let group of this.item.modifier_groups) {
                if (group.primary) {
                    continue;
                }

                for (let modifier of group.modifiers) {
                    if (modifier.selected == true || modifier.id == group.selected) {
                        price += modifier.price * modifier.quantity;
                    }
                }
            }

            return price * this.item.quantity;
        },
        back() {
            this.$router.push(this.previousUrl);
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => vm.previousUrl = from);
    },
    mounted() {
        this.fetchItem();
        this.fetchMenus();

        this.$pageTitle = this.$t("Items");
    }
};
</script>

<style lang="scss" scoped>
.custom-card-qty {
    margin-left: -17px;
    margin-top: 5px;
}
</style>
